import React from 'react';
import { Heart, Users, Flame, Backpack, Briefcase, Bus, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { DESTINATION_SPECIFIC_DATA } from '../../constants/destinationData';

const TRAVELER_TYPES = [
  { id: 'couples', icon: Heart, label: 'Romantic Couples', sub: '"Fall in love all over again"' },
  { id: 'family', icon: Users, label: 'Family Memories', sub: '"Smiles your family will never forget"' },
  { id: 'friends', icon: Flame, label: 'Friends Trip', sub: '"Unfiltered fun. Unlimited yaari."' },
  { id: 'solo', icon: Backpack, label: 'Solo Escape', sub: '"Discover yourself in the mountains"' },
  { id: 'corporate', icon: Briefcase, label: 'Corporate Tours', sub: '"Bond beyond the boardroom"' },
  { id: 'group', icon: Bus, label: 'Group Tours', sub: '"More people. More magic."' },
];

export default function TravelerTypes({ slug = 'shimla' }) {
  // We'll use some generic defaults since we don't have all types for every destination in mock
  const data = DESTINATION_SPECIFIC_DATA[slug] || DESTINATION_SPECIFIC_DATA['shimla'];
  const destName = slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

  return (
    <section className="py-20 bg-brand-grey/30 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-poppins text-[32px] lg:text-[44px] text-brand-blue leading-tight mb-4">{destName} Packages For <span className="text-brand-orange">Every Traveler</span></h2>
          <p className="text-brand-blue/60 text-[16px] lg:text-[18px]">Whether it's romance, family fun, corporate offsites or adventures with friends - we have your perfect package.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TRAVELER_TYPES.map((type, i) => (
            <div key={i} className="bg-white rounded-[2rem] overflow-hidden border border-brand-greyDark shadow-card hover:shadow-premium transition-all duration-300 group">
              <div className="p-8">
                <div className="w-12 h-12 rounded-2xl bg-brand-orange/10 text-brand-orange flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-transform">
                  <type.icon size={24} />
                </div>
                <h3 className="font-poppins font-bold text-[22px] text-brand-blue mb-2">{type.label}</h3>
                <p className="text-brand-orange italic text-[14px] mb-6">{type.sub}</p>
                
                <ul className="space-y-3 mb-8">
                  {['Handpicked Hotels', 'Private Transfers', 'Expert Local Guide'].map((item, j) => (
                    <li key={j} className="flex items-center gap-2.5 text-brand-blue/70 text-[14px]">
                      <div className="w-1.5 h-1.5 rounded-full bg-brand-orange" /> {item}
                    </li>
                  ))}
                </ul>

                <Button 
                  onClick={() => window.dispatchEvent(new CustomEvent('mct:openEnquiry'))}
                  className="w-full h-12 rounded-xl bg-brand-blue/5 hover:bg-brand-orange hover:text-white text-brand-blue font-bold border border-brand-blue/10 transition-all"
                >
                  View Packages <ArrowRight size={16} className="ml-2"/>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
